export class Parcel {
    length?: number;
    width?: number;
    height?: number;
    parcelNo: number;
    sameAsPrevious?: boolean;
    unknownDimensions?: boolean;
}
